import {Component, HostListener, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-success-dialog-fast',
  templateUrl: './success-dialog-fast.component.html',
  styleUrls: ['./success-dialog-fast.component.css']
})
export class SuccessDialogFastComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: {
                cancelText: string,
                confirmText: string,
                message: string,
                title: string
              },
              private mdDialogRef: MatDialogRef<SuccessDialogFastComponent>) { }

  public cancel() {
    this.close(false);
  }

  public close(value) {
    this.mdDialogRef.close(value);
  }

  public confirm() {
    this.close(true);
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.close(false);
  }
}
